<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div>
      <!-- 条件搜索 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline">
            <a-row :gutter="48">
              <a-col :md="6" :sm="24">
                <a-form-item prop="schoolName">
                  <span slot="label" ><a-tooltip>{{$t('学校名称')}}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                  <a-input v-model="queryParam.schoolName" :maxLength="32" :placeholder="$t('请输入')+'学校名称'" allow-clear @pressEnter="handleQuery"/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item prop="schoolCode">
                  <span slot="label" ><a-tooltip>{{$t('学校口令')}}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                  <a-input v-model="queryParam.schoolCode" :maxLength="32" :placeholder="$t('请输入')+$t('学校口令')" allow-clear @pressEnter="handleQuery"/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('学校所在省')" prop="schoolAreap">
                  <a-select :placeholder="$t('请选择')+$t('省份名称')" style="width: 100%" v-model="queryParam.schoolAreap" @change="schoolAreapChange" allowClear>
                    <a-select-option v-for="(item, index) in this.areaList" :value="item.areaId+''" :key="index">
                      {{ item.areaName }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('学校所在市')" prop="schoolAreac">
                  <a-select :placeholder="$t('请选择')+$t('城市')" style="width: 100%" v-model="queryParam.schoolAreac" allowClear>
                    <a-select-option v-for="(item, index) in this.cityList" :value="item.areaId+''" :key="index">
                      {{ item.areaName }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item prop="schoolAddress">
                  <span slot="label" ><a-tooltip>{{$t('详细地区')}}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                  <a-input v-model="queryParam.schoolAddress" :maxLength="32" :placeholder="$t('请输入')+'详细地区'" allow-clear @pressEnter="handleQuery"/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('负责人')" prop="leaderId">
                  <a-select  show-search :filter-option="leaderFilter"  v-model="queryParam.leaderId" :maxLength="32" :placeholder="$t('请选择')+$t('负责人')" allow-clear>
                    <a-select-option v-for="item in leaderList" :key="item.id">{{ item.leaderName }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('下单开始时间')" prop="createBeginTime">
                  <a-date-picker style="width: 100%" v-model="queryParam.createBeginTime"
                                 :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                                 valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('下单结束时间')" prop="createEndTime">
                  <a-date-picker style="width: 100%" v-model="queryParam.createEndTime"
                                 :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                                 valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('重置')}}</a-button>
              </span>
              </a-col>
            </a-row>
          </a-form>
          <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
            <img alt="example" style="width: 100%" :src="previewUrl" />
          </a-modal>
        </div>
      <!-- 操作 -->
        <div class="table-operations">
          <a-button type="primary" @click="handleExport" >
            <a-icon type="download" />{{$t('导出')}}
          </a-button>
          <a-button type="primary" :disabled="multiple"  @click="handleSelectExport">
            <a-icon type="download" />{{$t('选中导出')}}
          </a-button>
          <table-setting
            :style="{float: 'right'}"
            :table-size.sync="tableSize"
            v-model="columns"
            :refresh-loading="loading"
            @refresh="getList" />
        </div>
        <!-- 数据展示 -->
        <a-table
          v-table-sticky="{ fixedTop: 64 }"
          :scroll="{ x: 1200 }"
          class="sta-head-footer-table"
          :loading="loading"
          size="small"
          rowKey="goodsId"
          :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
          @change="handleSortChange"
          :columns="columns"
          :data-source="list"
          :pagination="false"
          :bordered="tableBordered"
        >

          <template slot="schoolLogo" slot-scope="text, record">
            <div>
              <img v-if="record.schoolLogo" :src="record.schoolLogo"  style="width:60px;height:62px;" @click="handleRecordPreview(record.schoolLogo)" alt="none"/>
            </div>
          </template>
          <span slot="goodsType" slot-scope="text, record">
            <custom-dict-tag :options="customDict.GoodsTypeEnum" :value="record.goodsType"/>
          </span>
          <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical"/>
          <a @click="jumpSchoolGoods(record)" >
             <a-icon type="edit" />{{$t('详情')}}
          </a>
        </span>
        </a-table>
        <!-- 分页 -->
        <a-pagination
          class="ant-table-pagination"
          show-size-changer
          show-quick-jumper
          :pageSizeOptions="pageSizeOptions"
          :current="queryParam.pageNum"
          :total="total"
          :page-size="queryParam.pageSize"
          :showTotal="total => getTotal(total)"
          @showSizeChange="onShowSizeChange"
          @change="changeSize"
        />
      </div>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import {schoolSta} from '@/api/statistics/school'
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import {tableMixin} from '@/store/table-mixin'
import moment from 'moment';
import {areaListTree} from "@/api/logistics";
import {listSchoolLeader} from "@/api/school/schoolLeader";
import {downLoadExcel} from "@/utils/excelDownload";


export default {
  name: 'Goods',
  components: {
    CustomDictTag,
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      leaderList: [],
      areaList: [],
      cityList: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo: {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        schoolName: undefined,
        schoolCode: undefined,
        schoolLogo: undefined,
        schoolAddress: undefined,
        schoolAreap: undefined,
        schoolAreac: undefined,
        leaderId: undefined,
        schoolStatus: undefined,
        schoolDescription: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('学校名称'),
          dataIndex: 'schoolName',
          align: 'center'
        },
        {
          title: this.$t('学校logo'),
          dataIndex: 'schoolLogo',
          scopedSlots: { customRender: 'schoolLogo' },
          align: 'center'
        },
        {
          title: this.$t('学校所在地'),
          dataIndex: 'schoolAreaxName',
          align: 'center'
        },
        {
          title: this.$t('详细地区'),
          dataIndex: 'schoolAddress',
          align: 'center'
        },
        {
          title: this.$t('负责人'),
          dataIndex: 'leaderName',
          align: 'center'
        },
        {
          title: this.$t('学校口令'),
          dataIndex: 'schoolCode',
          align: 'center'
        },
        {
          title: '商品销量',
          sortDirections: ['descend', 'ascend'],
          dataIndex: 'salesNum',
        },
        {
          title: '订单数',
          sortDirections: ['descend', 'ascend'],
          dataIndex: 'orderNum',
        },
        {
          title: '销售金额',
          sortDirections: ['descend', 'ascend'],
          dataIndex: 'payAmount',
        },
        {
          title: '运费',
          sortDirections: ['descend', 'ascend'],
          dataIndex: 'shippingPayAmount',
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: '5%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    };
  },
  filters: {
  },
  created () {
    this.defaultDate()
    this.getList()
    this.getAreaTree()
    this.getLeaderList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted() {
    this.resetQuery();
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    /** 查询商品列表 */
    getList () {
      this.loading = true
      schoolSta(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    defaultDate() {
      let now = new Date();
      this.queryParam.createEndTime =  moment(now).format('YYYY-MM-DD') + ' 23:59:59'; // "2023-10-05 14:30:45"
      const lastMonthToday = moment().subtract(3, 'months'); // 上个月的今天
      this.queryParam.createBeginTime =  lastMonthToday.format('YYYY-MM-DD') + ' 00:00:00'; // "2023-10-05 14:30:45"
    },

    getAreaTree() {
      areaListTree().then(response => {
        this.areaList = response.data
      })
    },
    getLeaderList() {
      listSchoolLeader({}).then(response => {
        this.leaderList = response.data
      })
    },
    leaderFilter(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    schoolAreapChange(areaId) {
      this.queryParam.schoolAreac = undefined
      if (!areaId) {
        this.cityList = []
        return
      }
      const province = this.areaList.find(p => (p.areaId + '') === (areaId + '') || p.areaId === areaId)
      this.cityList = (province && province.children) ? province.children : []
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        schoolName: undefined,
        schoolCode: undefined,
        schoolLogo: undefined,
        schoolAddress: undefined,
        schoolAreap: undefined,
        schoolAreac: undefined,
        leaderId: undefined,
        schoolStatus: undefined,
        schoolDescription: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.defaultDate()
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.goodsId)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },

    jumpSchoolGoods(record){
      //查看排行
      this.$router.push({
        path: '/statistics/school-goods-statistics',
        query: {schoolId: record.schoolId, schoolName: record.schoolName},
      })
    },

    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          downLoadExcel('biz/admin/statistics/school/export' ,  that.queryParam)
        },
        onCancel () {}
      })
    },
    handleSelectExport () {
      var that = this
      let queryParam = {"idList": this.ids}
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出选中数据'),
        onOk () {
          downLoadExcel('biz/admin/statistics/school/export' , queryParam)
          that.ids = []
          that.multiple = true;
          that.selectedRowKeys=[]
        },
        onCancel () {
          that.ids = []
          that.multiple = true;
          that.selectedRowKeys=[]
        }
      })
    }
  }
}
</script>
<style>
</style>
